/**
 * Старый кэш general_option_block отдавал <span class="icon" style="background-image: url(...option_N.svg)">.
 * Переводим на классы option_N для sprite-svg-themed (в т.ч. тёмная тема).
 */
export default function initGeneralOptionIcons() {
    document.querySelectorAll('.Hotel-general-options .icon').forEach(($icon) => {
        const bg = $icon.style.backgroundImage || '';
        const fromStyle = bg.match(/option_(\d+)\.svg/i);
        const fromAttr = ($icon.getAttribute('style') || '').match(/option_(\d+)\.svg/i);
        const match = fromStyle || fromAttr;

        if (!match) {
            return;
        }

        $icon.classList.add(`option_${match[1]}`);
        $icon.style.removeProperty('background-image');

        if (!$icon.getAttribute('style')?.trim()) {
            $icon.removeAttribute('style');
        }
    });
}
